import axios from 'axios';
import connAxios from "./Conn"

//const USER_API_BASE_URL = 'http://localhost:8080';
const USER_API_BASE_URL = process.env.REACT_APP_API_ENDPOINT + '/truck';

let config = {
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      }
}


class Truck {

    fetchTrucks() {
        return connAxios.get(USER_API_BASE_URL+'/listAll');
    }


    fetchTruckById(id) {
        return connAxios.get(USER_API_BASE_URL + '/' + id);
    }

    
    fetchTruckByBranch(idBranch) {
        return connAxios.get(USER_API_BASE_URL + '/listAllBranch' + idBranch);
    }

    deleteTruck(id) {
        return connAxios.put(USER_API_BASE_URL + '/update',id);
    }

    addTruck(truck) {
        return connAxios.post(USER_API_BASE_URL+'/add', truck);
    }

    editTruck(city) {
        return connAxios.put(USER_API_BASE_URL + '/update', city);
    }


}

export default new Truck();